/**
 * @file Created on Mon Nov 26 2018
 * @author wangyongqing <wangyongqing01@baidu.com>
 */
/**
 * 返回当前浏览器 UserAgent
 */
export default typeof window === 'object' && window.self === window ? navigator.userAgent : '';
